import React from 'react'

function Success() {
  return (
    <div>Success</div>
  )
}

export default Success